<template>
  <div class="form">
    <b-row>
      <b-col md="6">
        <b-form-group
          horizontal
          :label-cols="3"
          :label="$lang('姓：')"
          :feedback="errors.first('firstName')"
        >
          <b-form-input
            type="text"
            v-model="value.firstName"
            name="firstName"
            :class="errors.has('firstName') && 'is-invalid'"
            v-validate="{ ...rules.firstName, required: requiredType }"
            :placeholder="$lang('請輸入姓氏')"
            :disabled="disabled"
          />
          <b-form-invalid-feedback :state="errors.has('firstName')">
            {{ errors.first("firstName") }}
          </b-form-invalid-feedback>
        </b-form-group>
      </b-col>
      <b-col md="6">
        <b-form-group horizontal :label-cols="3" :label="$lang('名字：')">
          <b-form-input
            type="text"
            v-model="value.lastName"
            name="lastName"
            :class="errors.has('lastName') && 'is-invalid'"
            v-validate="{ ...rules.lastName, required: requiredType }"
            :placeholder="$lang('請輸入名字')"
            :disabled="disabled"
          />
          <b-form-invalid-feedback :state="errors.has('lastName')">
            {{ errors.first("lastName") }}
          </b-form-invalid-feedback>
        </b-form-group>
      </b-col>
      <b-col md="6">
        <b-form-group horizontal :label-cols="3" :label="$lang('出生日期：')">
          <DatePicker
            v-on:input="isChild(isIndividual)"
            type="date"
            v-model="value.bornAt"
            name="bornAt"
            size="large"
            :class="errors.has('bornAt') && 'is-invalid'"
            v-validate="{ ...rules.birth, required: requiredType }"
            format="yyyy/MM/dd"
            :disabled="disabled"
          ></DatePicker>
          <b-form-invalid-feedback :state="errors.has('bornAt')">
            {{ errors.first("bornAt") }}
          </b-form-invalid-feedback>
        </b-form-group>
      </b-col>
      <b-col md="6">
        <b-form-group horizontal :label-cols="3" :label="$lang('性別：')">
          <b-select
            v-model="value.gender"
            name="sex"
            :class="errors.has('sex') && 'is-invalid'"
            v-validate="{ ...rules.sex, required: requiredType }"
            :placeholder="$lang('請輸入性別')"
            :disabled="disabled"
          >
            <option value="M">{{ $lang("FIELD_MALE") }}</option>
            <option value="F">{{ $lang("FIELD_FEMALE") }}</option>
          </b-select>
          <b-form-invalid-feedback :state="errors.has('sex')">
            {{ errors.first("sex") }}
          </b-form-invalid-feedback>
        </b-form-group>
      </b-col>
      <b-col md="6" v-if="value.hasOwnProperty('phone')">
        <b-form-group horizontal :label-cols="3" :label="$lang('電話號碼：')">
          <b-form-input
            type="text"
            v-model="value.phone"
            name="phone"
            :class="errors.has('phone') && 'is-invalid'"
            v-validate="{
              ...rules.mobile,
              mobile: value.phone,
              required: requiredType,
            }"
            :placeholder="$lang('請輸入電話號碼')"
            :disabled="disabled"
          />
          <b-form-invalid-feedback :state="errors.has('phone')">
            {{ errors.first("phone") }}
          </b-form-invalid-feedback>
        </b-form-group>
      </b-col>
      <b-col md="6">
        <b-form-group
          horizontal
          :label-cols="3"
          :label="$lang('FIELD_ID_NUMBER_TYPE')"
        >
          <b-input-group>
            <b-form-select
              v-model="value.idType"
              name="idType"
              required
              :class="errors.has('idType') && 'is-invalid'"
              :disabled="disabled"
            >
              <option :value="1">{{ $lang("TEXT_ID_TYPE_MACAO") }}</option>
              <option :value="2">{{ $lang("TEXT_ID_TYPE_PASSPORT") }}</option>
              <option :value="3">{{ $lang("TEXT_ID_TYPE_OTHER") }}</option>
            </b-form-select>
            <b-form-invalid-feedback :state="errors.has('idType')">{{
              errors.first("idType")
            }}</b-form-invalid-feedback>
          </b-input-group>
        </b-form-group>
      </b-col>
      <b-col md="6">
        <b-form-group
          horizontal
          :label-cols="3"
          :label="$lang('FIELD_ID_NUMBER')"
        >
          <b-form-input
            type="text"
            v-model="value.idNumber"
            name="idNumber"
            :class="errors.has('idNumber') && 'is-invalid'"
            v-validate="{
              ...rules.idNumber,
              idNumber: value.idType == 1,
              required: requiredType,
            }"
            :placeholder="$lang('請輸入證件號碼')"
            :disabled="disabled"
          />
          <b-form-invalid-feedback :state="errors.has('idNumber')">
            {{ errors.first("idNumber") }}
          </b-form-invalid-feedback>
        </b-form-group>
      </b-col>
      <!-- 疫苗 -->
      <!-- <b-col md="12"
        ><div style="font-weight: 500">{{ $lang("新冠疫苗接種") }}</div></b-col
      >
      <b-col md="6">
        <b-form-group
          horizontal
          :label-cols="3"
          :label="$lang('第一針疫苗日期')"
        >
          <DatePicker
            type="date"
            v-model="value.firstVaccination"
            name="firstVaccination"
            size="large"
            :class="errors.has('firstVaccination') && 'is-invalid'"
            v-validate="{ required:false }"
            format="yyyy/MM/dd"
            :disabled="disabled"
          ></DatePicker>
          <b-form-invalid-feedback :state="errors.has('firstVaccination')">
            {{ errors.first("firstVaccination") }}
          </b-form-invalid-feedback>
        </b-form-group>
      </b-col>
      <b-col md="6">
        <b-form-group
          horizontal
          :label-cols="3"
          :label="$lang('第二針疫苗日期')"
        >
          <DatePicker
            type="date"
            v-model="value.secondVaccination"
            name="secondVaccination"
            size="large"
            :class="errors.has('secondVaccination') && 'is-invalid'"
            v-validate="{ required: false}"
            format="yyyy/MM/dd"
            :disabled="disabled"
          ></DatePicker>
          <b-form-invalid-feedback :state="errors.has('secondVaccination')">
            {{ errors.first("secondVaccination") }}
          </b-form-invalid-feedback>
        </b-form-group>
      </b-col> -->
      <b-col md="6" v-if="!disabled">
        <slot name="remove"></slot>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import InputFile from "@/components/InputFile";
export default {
  components: {
    InputFile,
  },
  data() {
    return {

    };
  },
  props: {
    value: {
      type: Object,
      default() {
        return {
          lastName: "",
          firstName: "",
          gender: "M",
          phone: "",
          bornAt: "",
          idType: 1,
          idNumber: "",
        };
      },
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    rules: {
      type: Object,
    },
    requiredType: {
      type: Boolean,
    },
    isIndividual: {
      type: Boolean,
      default: false,
    },
  },
  watch:{
   'value.bornAt'(n){
        this.$emit('isAdultNewTeam',n)
     
   }
  },
  methods: {
    onSubmit() {
      return new Promise((resolve, reject) => {
        this.$validator.validate().then((result) => {
          resolve(result);
        });
      });
    },
    validateErrors(field, msg) {
      this.errors.add({
        field,
        msg,
      });
    },
    isChild(isIndividual) {
      // console.log(isIndividual);
      if (isIndividual) {
        if (this.value.bornAt != "") {
          if (
            this.value.bornAt.getFullYear() >= 1966 &&
            this.value.bornAt.getFullYear() <= 2003
          ) {
            this.$parent.getGroupings(true);
            this.$parent.isAdultNew(true);

          } else {
            this.$parent.getGroupings(false);
            this.$parent.isAdultNew(false);

          }
          if (
            this.value.bornAt.getFullYear() >= 2006 &&
            this.value.bornAt.getFullYear() <= 2008
          ) {
            this.$parent.getGrouping(true);
            this.$parent.isAdultNew(false);
          } else {
            this.$parent.getGrouping(false);
          }
        }
      }
    },
  },
};
</script>
